export default {
    private: false,
    slug: 'at-a-glance',
    promo: 'AT-A-GLANCE FB Case study',
    meta: {
        title: 'AT-A-GLANCE FB Case study',
        description: 'he leader in planning products embarked on their first Foap-led video ad campaign on Facebook and left with a complete marketing strategy for the following year, unlocking the keys to engagement along the way.',
        ogImage: require('Theme/images/videoCaseStudies/at-a-glance/videoCaseStudy-at-a-glance-og.jpg')
    },
    hero: {
        visible: true,
        title: 'Case Study',
        logo: require('Theme/images/videoCaseStudies/at-a-glance/videoCaseStudy-at-a-glance-logo.png')
    },
    challenge: {
        visible: true,
        title: 'Heralding in the video-age',
        subtitle: 'AT-A-GLANCE® sought to enrich the conversation with their consumer base and ultimately grow their direct sales by experimenting with lifestyle-focused video content. Before going all in, they wanted to see how effective this new medium could be in driving engagement and brand awareness. ',
        video: {
            container: require('Theme/images/videoCaseStudies/videoCaseStudy-challenge-fbMock-empty.png'),
            poster: require('Theme/images/videoCaseStudies/at-a-glance/videoCaseStudy-at-a-glance-challenge-videoPoster.jpg'),
            assets: [{
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/webm_w640-foap-case-study-at-a-glance-2.webm',
                type: 'video/webm'
            }, {
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/mp4_w640-foap-case-study-at-a-glance-2.mp4',
                type: 'video/mp4'
            }]
        },
        float01: require('Theme/images/videoCaseStudies/at-a-glance/videoCaseStudy-at-a-glance-challenge-float01.jpg'),
        sideBg: require('Theme/images/videoCaseStudies/videoCaseStudy-challenge-sideBg.svg'),
    },
    whyUs: {
        visible: true,
        title: 'Organised and ready',
        description: 'AT-A-GLANCE® has been part of our ‘everyday’ for the past 75 years with their stylish planners, diaries, calendars and sticky notes. The company strives to hand working adults the right organisational tools to help them realise their goals, whether that be in the office or the home study.',
        elements: [{
            styles: { color: '#F5A623' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-rocket.svg'),
            title: '509%',
            desc: 'Higher Engagement'
        }, {
            styles: { color: '#4AD2FF' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-graph-lines.svg'),
            title: '96%',
            desc: 'Lower Cost Of Watched Video'
        }, {
            styles: { color: '#50E3C2' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-globe.svg'),
            title: '110 000+',
            desc: 'Video Plays'
        }],
        sideBg: require('Theme/images/videoCaseStudies/videoCaseStudy-whyus-sideBg.svg'),
        photo2: require('Theme/images/videoCaseStudies/at-a-glance/videoCaseStudy-at-a-glance-whyus-photo-02.jpg'),
        photo3: require('Theme/images/videoCaseStudies/at-a-glance/videoCaseStudy-at-a-glance-whyus-photo-03.jpg'),
    },
    solutionv2: {
        visible: true,
        title: 'Year of the video',
        subtitle: `
            There’s a good reason why AT-A-GLANCE has remained a market leader for over seven decades. They’re agile, always looking for new products and ways 
            to sell them.
            <br/><br/>
            Two years ago, they broke new territory by working with Foap for the first time to launch a targeted photo ad campaign on Facebook/Instagram. 
            And they’ve never looked back, enjoying success in subsequent campaigns.
            <br/><br/>
            Now they’re looking forward … to lifestyle-focused video ads. They were so impressed by the power of video advertising, 
            that they’ve marked 2019 as the year of video, with the medium forming as the linchpin to their social advertising strategy.
            <br/><br/>
            Having already seen the results Foap could generate with their tailor-made photo content, AT-A-GLANCE naturally turned to 
            the mobile-first marketing expert to quarterback their first video campaign. 
            <br/><br/>
            A multi-phase plan was drawn up based on the campaign concept of ‘Everyone has a story. Tell yours.’ A Video Mission was submitted 
            to Foap’s diverse community of 3 million creatives, with an emphasis on crowdsourcing branded lifestyle videos that would engage with key 
            prospects on Facebook and Instagram. The content needed to reinforce their brand messaging and encourage product exploration, particularly 
            towards their Harmony line. And most importantly, the ultimate goal was to drive click-through and sales. 
            <br/><br/>
            With the challenge gladly accepted, the Foap curators assembled a shortlist of videos for AT-A-GLANCE to choose from. The winning video
             assets were then optimised with specific target settings and uploaded to Facebook/Instagram via Foap’s integrated export console.    
        `
    },
    results: {
        visible: true,
        title: 'The big double-double',
        video: {
            poster: require('Theme/images/videoCaseStudies/at-a-glance/videoCaseStudy-at-a-glance-results-videoPoster.jpg'),
            assets: [{
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/webm_w640-foap-case-study-at-a-glance-3.webm',
                type: 'video/webm'
            }, {
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/mp4_w640-foap-case-study-at-a-glance-3.mp4',
                type: 'video/mp4'
            }]
        },
        textBlock: 'AT-A-GLANCE’s first video ad campaign was a big success on two levels. The data generated was priceless. It was used to shape their social advertising strategy for 2019, including a remarketing campaign to target viewers who failed to click-through or order. And for the kicker, their campaign delivered:  ',
        testimony: {
            title: 'Client testimony:',
            content: '“We have worked with Foap for two years on a variety of Photo Missions. Based on our past success, we decided to partner with the Foap team to guide our first video advertising campaign on Facebook. We were primarily fishing for engagement data to use for remarketing, but it was a nice bonus to see our CPM drop while our engagement rate skyrocketed.” <br /><br /> Susan Jackson, Digital Marketing Manager at AT-A-GLANCE',
        },
        list: [{
            styles: { color: '#50E3C2' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-graph-pie.svg'),
            title: '509%',
            subtitle: 'Higher Engagement Rate '
        }, {
            styles: { color: '#58D5FF' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-sync.svg'),
            title: '96%',
            subtitle: 'lower CPM than other engagement campaigns'
        }],
        photo1: require('Theme/images/videoCaseStudies/at-a-glance/videoCaseStudy-at-a-glance-results-photo-01.jpg'),
        photo2: require('Theme/images/videoCaseStudies/at-a-glance/videoCaseStudy-at-a-glance-results-photo-02.jpg'),
        bgSide: require('Theme/images/videoCaseStudies/videoCaseStudy-results-top.svg')
    },
    checkout: {
        visible: true
    }
};



// WEBPACK FOOTER //
// ./src/containers/global/VideoCaseStudy/data/atAGlance.js